// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
// console.log('🟢 hocLapTrinh.io();')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

// console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

import '../controllers'

// Example: Load Rails libraries in Vite.
//
import * as Turbo from '@hotwired/turbo'
Turbo.start()
//
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css

import 'flowbite/dist/flowbite.turbo'

// Roboto
import "@fontsource/roboto";
import "@fontsource/roboto/700.css";
import "@fontsource/roboto/400-italic.css";
import "@fontsource/roboto/700-italic.css";
// Public Sans
import "@fontsource/public-sans";
import "@fontsource/public-sans/700.css";
import "@fontsource/public-sans/400-italic.css";
import "@fontsource/public-sans/700-italic.css";

// Font Awesome
import '@fortawesome/fontawesome-free/js/fontawesome';
import '@fortawesome/fontawesome-free/js/solid';
import '@fortawesome/fontawesome-free/js/regular';
import '@fortawesome/fontawesome-free/js/brands';

import '../src/main'
import '../src/scrolltop'

import 'js-toc'
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

import '@/builds/tailwind.css'

document.addEventListener('turbo:load', () => {
  fbAsyncInit()
})
